export default __webpack_public_path__ + "0739de557569ab8d62da125cef6792cc.png";